import { Routes } from '@angular/router';
import { Path, RoutePath } from './shared/route';
import { authGuard } from './guards/auth/auth.guard';
import { adminGuard } from 'src/app/guards/admin/admin.guard';
import { DashboardPageComponent } from './pages/dashboard/dashboard.component';

export const APP_ROUTES: Routes = [
  {
    path: RoutePath.getPath(Path.auth).relativePath.join('/'),
    loadChildren: () => import('./pages/auth/auth.routes').then((c) => c.AUTH_ROUTES),
  },
  {
    path: RoutePath.getPath(Path.dashboard).relativePath.join('/'),
    canActivate: [authGuard],
    component: DashboardPageComponent,
  },
  {
    path: RoutePath.getPath(Path.products).relativePath.join('/'),
    canActivate: [authGuard],
    loadChildren: () => import('./pages/product/product.routes').then((c) => c.PRODUCT_ROUTES),
  },
  {
    path: RoutePath.getPath(Path.admin).relativePath.join('/'),
    canActivate: [authGuard],
    canActivateChild: [adminGuard],
    loadChildren: () => import('./pages/admin/admin.routes').then((r) => r.ADMIN_ROUTES),
  },
  {
    path: RoutePath.getPath(Path.setting).relativePath.join('/'),
    canActivate: [authGuard],
    loadChildren: () => import('./pages/setting/setting.routes').then((r) => r.SETTING_ROUTES),
  },
  // {
  //   path: RoutePath.getPath(Path.keywords).relativePath.join('/'),
  //   canActivate: [authGuard],
  //   loadChildren: () => import('./pages/keywords/keywords.routes').then((r) => r.KEYWORDS_ROUTES),
  // },
  {
    path: RoutePath.getPath(Path.plans).relativePath.join('/'),
    loadComponent: () => import('./pages/plans/plans.component').then((c) => c.PlansPageComponent),
  },
  {
    path: RoutePath.getPath(Path['plans/contact']).relativePath.join('/'),
    loadComponent: () => import('./pages/plans/contact/contact.component').then((c) => c.PlansContactPageComponent),
  },
  {
    path: RoutePath.getPath(Path['plans/invite/:token']).relativePath.join('/'),
    canActivate: [authGuard],
    loadComponent: () => import('./pages/plans/invite/invite.component').then((c) => c.PlanInvitePageComponent),
  },
  {
    path: RoutePath.getPath(Path.charts).relativePath.join('/'),
    canActivate: [authGuard],
    loadChildren: () => import('./pages/charts/charts.routes').then((r) => r.CHARTS_ROUTES),
  },
  {
    path: RoutePath.getPath(Path.inventory).relativePath.join('/'),
    canActivate: [authGuard],
    loadComponent: () => import('./pages/inventory/inventory.component').then((r) => r.InventoryPageComponent),
  },
  {
    path: RoutePath.getPath(Path.analytic).relativePath.join('/'),
    canActivate: [authGuard],
    loadChildren: () => import('./pages/analytic/analytic.routes').then((r) => r.ANALYTIC_ROUTES),
  },
  {
    path: RoutePath.getPath(Path['table-chart']).relativePath.join('/'),
    canActivate: [authGuard],
    loadChildren: () => import('./pages/table-chart/table-chart.routes').then((r) => r.CHART_TABLE_ROUTES),
  },
  {
    path: RoutePath.getPath(Path.sidekick).relativePath.join('/'),
    canActivate: [authGuard],
    loadComponent: () => import('./pages/sidekick/sidekick.component').then((r) => r.SidekickPageComponent),
  },
  {
    path: '**',
    redirectTo: RoutePath.getPath(Path['auth/signin']).fullPath.join('/'),
  },
];
